import { graphql } from "react-apollo";
import gql from "graphql-tag";
import format from "date-fns/format";

import React from "react";
import { connect } from "react-redux";

import * as actions from "../actions/actions";
import NounProjectIconHero from "../components/nounproject-icon-hero";

let Loading = require("../components/loading");

import "intl";
import "intl/locale-data/jsonp/en.js";

class IconDetail extends React.Component {
    render() {
        return (
            <NounProjectIconHero
                iconId={this.props.iconId}
                scrollToElement={this.props.scrollToElement}
                showInModal={this.props.showInModal}
                icon={this.props.data.iconDetail}
                collection={{}}
                onCloseAction={this.props.onCloseAction}
                refetchIcon={this.props.data.refetch}
            />
        );
    }
}

function mapStateToProps(state, ownProps) {
    let iconId = ownProps.match
        ? ownProps.match.params.iconId
        : ownProps.iconId;
    return {
        iconId
    };
}

const iconListQuery = gql`
    query IconDetailQuery($iconId: ID) {
        iconDetail(id: $iconId) {
            id
            isActive
            name
            term
            permalink
            tags {
                id
                slug
            }
            collections {
                id
                name
                slug
                permalink
            }
            icon_url: iconUrl
            license_description: licenseDescription
            uploader {
                id
                name: fullName
                username
                permalink
                location
            }
            userHasPurchased
            attributionPreviewUrl
            preview_url: thumbnail
        }
    }
`;

let IconDetailWithQuery = graphql(iconListQuery, {
    options: props => {
        return {
            variables: {
                iconId: props.iconId
            }
        };
    }
})(IconDetail);

export default connect(
    mapStateToProps,
    {}
)(IconDetailWithQuery);
